import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ConsentModal } from '@appsource/containers/modals/consentModal';
import { Constants } from '@shared/utils/constants';
import { SignInModal } from '@shared/containers/modals/signInModalContainer';
import { getSignInModalType, isTransactApp, isPrivateOffer, isPowerBIVisuals, isOfferCustomMeter, shouldRedirectToIbiza } from '@shared/utils/appUtils';
import { isAppContactForm } from '@shared/utils/modals';
import AnimationModal from '@shared/components/modals/animationModal';
import { getPrimaryProductUrl } from '@shared/utils/datamappingHelpers';
export function handleConsentModalCall(props, appData, dismissModal, service) {
    let modalContent = null;
    const { options, isEmbedded, billingCountryCode, userInfo, entityId, query } = props;
    const ctaType = parseInt(options.ctaType, 10);
    const isTransactable = isTransactApp({
        isEmbedded,
        ctaTypes: [
            ctaType
        ],
        appData,
        billingRegion: billingCountryCode
    }) && !isOfferCustomMeter(appData.skuAggregatedData) && !shouldRedirectToIbiza(appData) || isPrivateOffer(appData === null || appData === void 0 ? void 0 : appData.appType) && !isPowerBIVisuals(getPrimaryProductUrl(appData.primaryProduct));
    const signinType = getSignInModalType(appData && appData.primaryProduct, appData && appData.products, userInfo, ctaType, !!service, isTransactable);
    const { signedIn, loading } = props.userInfo;
    const shouldShowAnimationModal = !!(!signedIn && loading);
    const shouldShowSignInModal = signinType !== Constants.SignInType.Authorized && !props.isEmbedded;
    const signinRedirect = !!service && !appData ? 'service' : 'app';
    const entityType = !!service && !appData ? Constants.EntityType.Service : Constants.EntityType.App;
    if (shouldShowAnimationModal) {
        modalContent = /*#__PURE__*/ _jsx(AnimationModal, {});
    }
    if (shouldShowSignInModal && !shouldShowAnimationModal) {
        const appTitle = appData && appData.title ? appData.title : '';
        const userEmail = userInfo && userInfo.email ? userInfo.email : '';
        const serviceTitle = service && service.title ? service.title : '';
        modalContent = /*#__PURE__*/ _jsx(SignInModal, {
            redirect: signinRedirect,
            entityId: entityId,
            dismissModal: dismissModal,
            signInModalType: signinType,
            appName: appTitle,
            email: userEmail,
            entityType: entityType,
            serviceName: serviceTitle,
            ctaType: ctaType
        });
    } else if (appData || service) {
        modalContent = /*#__PURE__*/ _jsx(ConsentModal, {
            appInfo: appData,
            isEmbedded: isEmbedded,
            isContactForm: isAppContactForm(appData, ctaType),
            dismissModal: dismissModal,
            ctaType: ctaType,
            serviceInfo: service,
            query: query,
            isTransactApp: isTransactable,
            selectedPlanId: options.planId
        });
    }
    return modalContent;
}
